export default "__VITE_ASSET__DMnZVnXE__"